export default async function checkIPService(
    ip: string,
    onSuccess?: (isAllowAccess: boolean) => void,
    onError?: (error: string) => void
) {
    try {
        const notAllowAccessCountries = process.env.NEXT_PUBLIC_NOT_ALLOW_COUNTRIES?.split(",") || [];

        if (notAllowAccessCountries.length === 0) return onSuccess?.(false);

        const response = await fetch(`https://get.geojs.io/v1/ip/geo/${ip}.json`);
        if (!response.ok) {
            throw new Error(`GeoJS API failed with status: ${response.status}`);
        }
        const data = await response.json();

        const isAccessDenied = data.country_code ? notAllowAccessCountries.includes(data.country_code) : false;
        console.log("🚀 ~ checkIPService ~ isAccessDenied:", isAccessDenied);

        onSuccess?.(isAccessDenied);

        return isAccessDenied;
    } catch (error) {
        onError?.(error as string);
    }
}
